export const FETCH_JOB_FORM_REQUEST = 'FETCH_JOB_FORM_REQUEST';
export const FETCH_JOB_FORM_SUCCESS = 'FETCH_JOB_FORM_SUCCESS';
export const FETCH_JOB_FORM_FAILURE = 'FETCH_JOB_FORM_FAILURE';

export const FETCH_CANDIDATE_FORM_REQUEST = 'FETCH_CANDIDATE_FORM_REQUEST';
export const FETCH_CANDIDATE_FORM_SUCCESS = 'FETCH_CANDIDATE_FORM_SUCCESS';
export const FETCH_CANDIDATE_FORM_FAILURE = 'FETCH_CANDIDATE_FORM_FAILURE';